import {
  inboundShipmentIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const ReceivingSessionLineItemInput_ = z.object({
  // Use productId since products are aggregated across POs in the shipment view
  productId: productIdFormat.schema,
  receivedQuantity: z.number().int().min(0),
  discrepancy: z.number().int(),
  damagedQuantity: z.number().int().min(0),
  missingQuantity: z.number().int().min(0),
});

export const ReceivingSessionLineItemInput: z.ZodType<ReceivingSessionLineItemInput> =
  ReceivingSessionLineItemInput_;
export interface ReceivingSessionLineItemInput
  extends z.infer<typeof ReceivingSessionLineItemInput_> {}

export const saveReceivingSession = {
  name: "saveReceivingSession" as const,
  input: z.object({
    shipmentId: inboundShipmentIdFormat.schema,
    notes: z.string().nullish(),
    lineItems: z.array(ReceivingSessionLineItemInput),
  }),
  output: z.object({ success: z.boolean() }),
};
